<app-header></app-header>
<div [ngClass]="!router.url.includes('/network-market/product-marketplace/')?'mt-88':''" id="padding">
        <router-outlet></router-outlet>
</div>
<div [hidden]="router.url.includes('/network-market/product-marketplace/')">
        <app-website-footer></app-website-footer>
</div>